export { HeaderComponent } from '@shared/layout/header/header.component';
export { HeaderModule } from '@shared/layout/header/header.module';

export * from '@shared/layout/header/full-screen'
export * from '@shared/layout/header/collapse-menu'
export * from '@shared/layout/header/recent-projects'
export * from '@shared/layout/header/activities'



// WEBPACK FOOTER //
// ./src/app/shared/layout/header/index.ts